import { Fragment } from 'react';
// MUI
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
// REDUX
import { useAppSelector } from 'store';
// CUSTOM HOOKS
import useAuth from 'hooks/useAuth';
import useNavigate from 'hooks/useNavigate';
// CUSTOM ICON COMPONENT
import EmailOutlinedIcon from 'icons/EmailOutlined';

/**
 * Simplified notifications icon component
 * Shows notification count in a red badge (only for authenticated users)
 * On click navigates to trips with label type filter
 */
export default function NotificationsPopover() {
  const { isAuthenticated } = useAuth();
  const navigation = useNavigate();
  
  // Get new messages count from Redux
  const newMessagesCount = useAppSelector(
    (state) => state.notifications.newMessagesCount
  );

  const handleNotificationClick = () => {
    const labelTypeFilter = encodeURIComponent(
      JSON.stringify([{ values: [13, 14], displayName: 'New messages' }])
    );
    navigation(`/dashboard/trips/list?labelType=${labelTypeFilter}&viewFilters=1`);
  };

  // Don't show if not authenticated
  if (!isAuthenticated) return null;

  return <Fragment>
    <IconButton onClick={handleNotificationClick}>
      <Badge 
        color="error" 
        badgeContent={newMessagesCount}
        sx={{
          '& .MuiBadge-badge': {
            backgroundColor: '#d32f2f',
            color: '#fff',
            boxShadow: `0 0 0 2px #fff`,
            '&::after': {
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              animation: 'ripple 1.2s infinite ease-in-out',
              border: '1px solid currentColor',
            },
          },
          '@keyframes ripple': {
            '0%': {
              transform: 'scale(.8)',
              opacity: 1,
            },
            '100%': {
              transform: 'scale(2.4)',
              opacity: 0,
            },
          },
        }}
      >
        <EmailOutlinedIcon sx={{ color: 'grey.400' }} />
      </Badge>
    </IconButton>
  </Fragment>;
}